import { useMemo } from "react";
import { Container, Content, FlexRow, TitleStyel } from "./style";
import { BondDetailType } from "./type";
import Text from "../common/Text";
import { GRAY_565656 } from "../../constants/colors";

const menuCorp = [
  "อายุหุ้นกู้",
  "อายุคงเหลือ",
  "ความเสี่ยง",
  "วันครบกำหนดไถ่ถอน",
  "มูลค่าต่อหน่วย ณ วันออกหุ้นกู้",
  "งวดการจ่ายดอกเบี้ย",
];

const menuSaving = [
  "วันที่ออกตราสาร",
  "วันครบกำหนดไถ่ถอน",
  "ราคาต่อหน่วยเริ่มต้น",
  "การซื้อขั้นต่ำ",
  "ทวีคูณครั้งละ",
];

const BondDetail = (props: BondDetailType) => {
  const { detail, bondType } = props;

  const data = useMemo(() => {
    const { issueDate, maturityDate, parValue, bondAge, bondRemainingAge, bondRiskLevel, originalParValue, couponFrequency, currency, } = detail || {};
    const getCouponFrequencyDescription = () => {
      switch (couponFrequency) {
        case "1":
          return "ทุก 12 เดือน หรือ\nปีละ 1 ครั้ง";
        case "2":
          return "ทุก 6 เดือน หรือ\nปีละ 2 ครั้ง";
        case "4":
          return "ทุก 3 เดือน หรือ\nปีละ 4 ครั้ง";
        case "12":
          return "ทุก 1 เดือน หรือ\nปีละ 12 ครั้ง";
      }
    };
    const isBondTypeSaving = bondType === "SB";

    return isBondTypeSaving
      ? {
        info1: issueDate ? `${issueDate}` : "-",
        info2: maturityDate ? `${maturityDate}` : "-",
        info3: parValue ? `${parValue.toLocaleString()} ${currency ? (currency === "THB" ? "บาท" : currency) : "บาท"}` : "-",
      }
      : {
        info1: bondAge ? `${bondAge}` : "-",
        info2: bondRemainingAge ? `${bondRemainingAge}` : "-",
        info3: bondRiskLevel ? `${bondRiskLevel}` : "-",
        info4: maturityDate ? `${maturityDate}` : "-",
        info5: originalParValue
          ? `${originalParValue.toLocaleString()} ${currency ? (currency === "THB" ? "บาท" : currency) : "บาท"}`
          : "-",
        info6: couponFrequency ? getCouponFrequencyDescription() : "-",
      };
  }, [detail, bondType]);

  const title = useMemo(() => {
    if (bondType === "SB") {
      return "ข้อมูลพันธบัตร";
    }
    return "ข้อมูลหุ้นกู้";
  }, [bondType]);

  const content = useMemo(() => {
    let menu = menuCorp;
    if (bondType === "SB") {
      menu = menuSaving;
    }
    return Object.entries(data).map(([key, value], index) => {
      return (
        <FlexRow key={`${index}`}>
          <Text color={GRAY_565656}>{menu[index]}</Text>
          <div style={{ width: 130, textAlign: "end" }}>
            <div className={`text-[16px]/[24px] text-black-normal ${key === "info6" && "whitespace-pre"}`}>{value}</div>
          </div>
        </FlexRow>
      );
    });
  }, [data, bondType]);

  return (
    <Container>
      <TitleStyel weight={600}>{title}</TitleStyel>
      <Content>{content}</Content>
    </Container>
  );
};

export default BondDetail;
